export function vistaA() {
    return [{
        "Nombre": "18.50",
        "path": require('../UI/miniatures/second.jpg')
    },
    {
        "Nombre": "39.50",
        "path": require('../UI/miniatures/firts.jpg')
    },
    {
        "Nombre": "59.50",
        "path": require('../UI/miniatures/third.jpg')
    }
 
    ]
}